
import {
    DELETE_VENDOR_MASTER_REQUEST,
    FETCH_VENDOR_MASTER_FAILURE,
    FETCH_SINGLE_VENDOR_MASTER_REQUEST,
    FETCH_VENDOR_MASTER_REQUEST,
    FETCH_VENDOR_MASTER_SUCCESS,
    NAVIGATE_VENDOR_MASTER,
    FETCH_SINGLE_VENDOR_MASTER_SUCCESS,
    DELETE_VENDOR_MASTER_SUCCESS,
    FETCH_SINGLE_VENDOR_MASTER_FAILURE,
    DELETE_VENDOR_MASTER_FAILURE,
    UPDATE_VENDOR_MASTER_SUCCESS,
    UPDATE_VENDOR_MASTER_REQUEST,
    UPDATE_VENDOR_MASTER_FAILURE,
    CREATE_VENDOR_MASTER_FORM_MASTER,
    REJECT_SINGLE_VENDOR_MASTER_SUCCESS,
    APPROVE_SINGLE_VENDOR_MASTER_SUCCESS,
    SET_GST_FILE_NAME_VENDOR_MASTER,
    SET_PAN_FILE_NAME_VENDOR_MASTER,
    FILE_UPLOAD_DATA_VENDOR_GET_LIST_SUCCESS,
    APPROVE_TOGGLE,
    FETCH_PARTY_DETAILS_DATA_SUCCESS,
    FETCH_PARTY_DETAILS_DATA_REQUEST,
    FETCH_PARTY_DETAILS_DATA_FAILURE,
    FETCH_APPROVE_WITH_OUT_OVERWRITE_SUCCESS,
    FETCH_APPROVE_WITH_OVERWRITE_SUCCESS,
    UPDATE_UPLOAD_PREVIEW_IMG,
    UPDATE_UPLOAD_PREVIEW_IMG_SUCCESS,
    APPROVE_VENDOR_MASTER_SUCCESS,
    FETCH_VENDOR_MASTER_BY_USER_SUCCESS,
    FETCH_PENDING_VENDOR_MASTER_REQUEST,
    FETCH_PENDING_VENDOR_MASTER_SUCCESS,
    FETCH_PENDING_VENDOR_MASTER_FAILURE,
    FETCH_USER_HEADER_SUCCESS,
    FETCH_USER_HEADER_FAILURE,
    FETCH_USER_HEADER_REQUEST
} from "./vendorMaster.actionType";


export const VENDOR_MASTER = 'vendorMaster';

let initialState = {
    loading: false,
    vendorMaster: [],
    pendingvendor: [],
    vendorMasterByUser: [],
    vendorMasterform: {},
    selectedRow: {},
    activeKey: 1,
    errorMessage: '',
    isVendorDetails: false,
    uploadId: '',
    idApproveModal: false,
    partyDetailsData: [],
    approvewithoutOverwrite: {},
    approvewithOverwrite: {},
    uploadPreviewImg: {
        GST: null,
        PAN: null,
        Aadhaar: null,
        Passbook: null,
        TDSorTCSDeclaration: null,
        DeclarationofMSME: null,
    },
    userHeaderData: {},

}

export let vendorMasterReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_VENDOR_MASTER_REQUEST:
        case FETCH_SINGLE_VENDOR_MASTER_REQUEST:
        case FETCH_PARTY_DETAILS_DATA_REQUEST:
        case UPDATE_VENDOR_MASTER_REQUEST:
        case DELETE_VENDOR_MASTER_REQUEST:
        case FETCH_PENDING_VENDOR_MASTER_REQUEST:
        case FETCH_USER_HEADER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_VENDOR_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                vendorMaster: updatePayload
            };
        case FETCH_PENDING_VENDOR_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                pendingvendor: updatePayload
            };
        case FETCH_VENDOR_MASTER_BY_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                vendorMasterByUser: updatePayload
            };
        case FETCH_SINGLE_VENDOR_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                vendorMasterform: { ...updatePayload, fldisGstAvail: updatePayload.fldGSTNo === 'NA' ? true : false },
                selectedRow: updatePayload,
                activeKey: 1,
            };
        case FETCH_PARTY_DETAILS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                partyDetailsData: updatePayload,
            }
        case FETCH_APPROVE_WITH_OUT_OVERWRITE_SUCCESS:
            return {
                ...state,
                loading: false,
                approvewithoutOverwrite: updatePayload
            }
        case FETCH_APPROVE_WITH_OVERWRITE_SUCCESS:
            return {
                ...state,
                loading: false,
                approvewithOverwrite: updatePayload
            }
        case CREATE_VENDOR_MASTER_FORM_MASTER:
            return {
                ...state,
                loading: false,
                vendorMasterform: {
                    ...state.vendorMasterform,
                    [payload.key]: payload.value
                }
            };
        case UPDATE_VENDOR_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                vendorMasterform: {},
                uploadId: updatePayload
            };
        case REJECT_SINGLE_VENDOR_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                vendorMasterform: updatePayload,
            };
        case DELETE_VENDOR_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                vendorMasterform: {}
            };
        case APPROVE_VENDOR_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                vendorMasterform: updatePayload,
            };
        case APPROVE_SINGLE_VENDOR_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                vendorMasterform: updatePayload,
            };
        case FILE_UPLOAD_DATA_VENDOR_GET_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                uploadPreviewImg: updatePayload
            }
        case FETCH_USER_HEADER_SUCCESS:
            return {
                ...state,
                loading: false,
                userHeaderData: updatePayload
            };
        // case UPDATE_UPLOAD_PREVIEW_IMG_SUCCESS:
        //     return {
        //         ...state,
        //         loading: false,
        //         uploadPreviewImg: updatePayload
        //     };

        case SET_PAN_FILE_NAME_VENDOR_MASTER:
            return {
                ...state,
                loading: false,
                panFileName: payload
            };
        case SET_GST_FILE_NAME_VENDOR_MASTER:
            return {
                ...state,
                loading: false,
                gstFileName: payload
            };
        case FETCH_VENDOR_MASTER_FAILURE:
        case FETCH_SINGLE_VENDOR_MASTER_FAILURE:
        case FETCH_PARTY_DETAILS_DATA_FAILURE:
        case UPDATE_VENDOR_MASTER_FAILURE:
        case DELETE_VENDOR_MASTER_FAILURE:
        case FETCH_PENDING_VENDOR_MASTER_FAILURE:
        case FETCH_USER_HEADER_FAILURE:
            return {
                ...state,
                loading: false
            };

        case NAVIGATE_VENDOR_MASTER:
            return {
                ...state,
                isVendorDetails: false
            };

        case APPROVE_TOGGLE: {
            return {
                ...state,
                idApproveModal: payload
            };
        }
        default:
            return state;
    }
}